import { useTranslation } from "react-i18next";
import { OldValue } from "../../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../../helpers/historyHelpers/components/NewValue";
import { Label } from "../../../../../helpers/historyHelpers/components/Label";
import { firstToUpper } from "../../../../../../../utils/helpers/string";
import { renderSettingsResourceLabel } from "../../../../../../../utils/helpers/settings";

const fields = ["description", "effectiveDate", "rules"];

const RenderItem = ({ data }) => {
    const { t } = useTranslation();

    const renderValues = (item, data) => {
        const newValue = data?.[item].new;
        const oldValue = data?.[item].old;

        if (!data) return null;

        switch (item) {
            case "effectiveDate":
            case "description": {
                return (
                    <div className="d-flex align-items-center">
                        {oldValue && <OldValue value={t(oldValue)} />}
                        {newValue && <NewValue value={t(newValue)} />}
                    </div>
                );
            }
            case "rules": {
                const rulesNewValue = data[item]?.new.map((item) => {
                    return (
                        <div key={item} className="tooltip-border-style py-2">
                            {item?.amount && (
                                <span>
                                    {t("amount")}: {item.amount}
                                </span>
                            )}
                            {item?.duration && (
                                <span>
                                    {t("duration")}: {item.duration}
                                </span>
                            )}
                            {item?.payCode && (
                                <span>
                                    {t("pay-code")}: {renderSettingsResourceLabel(item.payCode)}
                                </span>
                            )}
                        </div>
                    );
                });
                const rulesOldValue = data[item]?.old.map((item) => {
                    return (
                        <div key={item} className="tooltip-border-style py-2">
                            {item?.amount && (
                                <span>
                                    {t("amount")}: {item.amount}
                                </span>
                            )}
                            {item?.duration && (
                                <span>
                                    {t("duration")}: {item.duration}
                                </span>
                            )}
                            {item?.payCode && (
                                <span>
                                    {t("pay-code")}: {renderSettingsResourceLabel(item.payCode)}
                                </span>
                            )}
                        </div>
                    );
                });

                return (
                    <div className="d-flex align-items-center">
                        <OldValue value={rulesOldValue} />
                        <NewValue value={rulesNewValue} />
                    </div>
                );
            }
            default:
                return null;
        }
    };

    return (
        <div className="tooltip-content-style text-left">
            {fields.map((item) => {
                if (!data[item]) return null;

                return (
                    <div key={item} className="py-1 d-flex flex-column gap-2">
                        <Label value={firstToUpper(t(item))} /> {renderValues(item, data)}
                    </div>
                );
            })}
        </div>
    );
};

export default RenderItem;
